import React, {lazy} from 'react';
import {RoutePermittedRole} from '@crema/constants/AppEnums';

const PortfolioListing = lazy(
  () => import('../../../modules/dashboards/Projects'),
);
const PortfolioDetails = lazy(
  () => import('../../../modules/dashboards/Projects/Details'),
);
const CreatePortfolio = lazy(
  () => import('../../../modules/dashboards/Portfolio/CreatePortfolio'),
);
const EditPortfolio = lazy(
  () => import('../../../modules/dashboards/Portfolio/EditPortfolio'),
);
const OurPartners = lazy(
  () => import('../../../modules/dashboards/Projects/OurPartners'),
);

const AllCategories = lazy(
  () => import('../../../modules/dashboards/AllCategories'),
);

const Blog = lazy(() => import('../../../modules/dashboards/Blog'));
const BlogDetail = lazy(
  () => import('../../../modules/dashboards/Blog/BlogDetail'),
);
const BlogCreate = lazy(
  () => import('../../../modules/dashboards/Blog/CreateBlog'),
);
const BlogEditPage = lazy(
  () => import('../../../modules/dashboards/Blog/EditBlog'),
);
const Portfolio = lazy(() => import('../../../modules/dashboards/Portfolio'));

export const dashBoardConfigs = [
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/projects',
    element: <PortfolioListing />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/project/details/:id',
    element: <PortfolioDetails />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/our-partners',
    element: <OurPartners />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: ['/categories', '/categories/:slug'],
    element: <AllCategories />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/create-portfolio',
    element: <CreatePortfolio />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/portfolio-listing',
    element: <Portfolio />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/update-portfolio/:id',
    element: <EditPortfolio />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/blog-details/:id',
    element: <BlogDetail />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/blog-listing',
    element: <Blog />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/create-blog',
    element: <BlogCreate />,
  },
  {
    permittedRole: [RoutePermittedRole.Admin],
    path: '/update-blog/:id',
    element: <BlogEditPage />,
  },
];
